if (!Array.prototype.find) {
  Array.prototype.find = function(predicate: any) {
    if (this == null) {
      throw new TypeError('Array.prototype.find called on null or undefined');
    }
    if (typeof predicate !== 'function') {
      throw new TypeError('predicate must be a function');
    }
    const list = Object(this);
    const length = list.length >>> 0;
    const thisArg = arguments[1];
    let value;

    for (let i = 0; i < length; i++) {
      value = list[i];
      if (predicate.call(thisArg, value, i, list)) {
        return value;
      }
    }
    return undefined;
  };
}

if (!String.prototype.startsWith) {
  String.prototype.startsWith = function(searchString: string, position: number){
    position = position || 0;
    return this.substr(position, searchString.length) === searchString;
  };
}